<template>
  <fragment>
    <video-player
      v-if="displayOption(value).fileName"
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions()"
      :playsinline="true"
    >
    </video-player>
  </fragment>
</template>

<script>
import VideoPlayer from "./video-player";
export default {
  components: {
    VideoPlayer
  },
  props: {
    value: {
      default: ""
    },
    name: {
      type: String
    },
    option: {
      type: Function,
      default: () => ({
        filePath: "",
        fileName: ""
      })
    }
  },
  methods: {
    displayOption(value) {
      return this.option(value) || {};
    },
    playerOptions() {
      const value = this.value;
      return {
        autoplay: false,
        language: "en",
        fluid: true,
        controls: true,
        sources: [
          {
            type: "video/mp4",
            src: this.displayOption(value).filePath
          }
        ]
      };
    }
  }
};
</script>

<style module lang="scss"></style>

<style scoped lang="scss">
.video-player-box {
  width: 60%;
}
</style>
